var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltips"},[_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('a',_vm._g({on:{"click":function($event){$event.stopPropagation();}}},on),[_c('v-icon',[_vm._v(_vm._s(_vm.ICONS.mdiAlertCircle))])],1)]}}])},[_vm._v(" "+_vm._s(_vm.descricao)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }